import { graphql } from '@/lib/query'
import ImageFragment from '../image'
import LinkFragment from '../link'
import ParentTreeFragmentAllLocales from '../parent-tree/all-locales'
import RedirectLinkFragment from '../redirect-link'
import { SectionBuilderFragment } from '../section-builder'
import TagFragment from '../tag'

const PageCardFragment = graphql(
  /* GraphQL */ `
    fragment PageCardFragment on PageRecord @_unmask {
      redirect {
        ...RedirectLinkFragment
      }
      _allSlugLocales {
        locale
        value
      }
      pageTitle
      excerpt
      subtitle
      slug
      image {
        ...ImageFragment
      }

      ...ParentTreeFragmentAllLocales
    }
  `,
  [
    LinkFragment,
    ParentTreeFragmentAllLocales,
    RedirectLinkFragment,
    ImageFragment
  ]
)

const PageFragment = graphql(
  /* GraphQL */ `
    fragment PageFragment on PageRecord @_unmask {
      _seoMetaTags {
        ...TagFragment
      }
      redirect {
        ...RedirectLinkFragment
      }
      _allSlugLocales {
        locale
        value
      }
      pageTitle
      excerpt
      subtitle
      slug
      image {
        ...ImageFragment
      }
      sections {
        ...SectionBuilderFragment
      }
      ...ParentTreeFragmentAllLocales
    }
  `,
  [
    LinkFragment,
    ParentTreeFragmentAllLocales,
    RedirectLinkFragment,
    TagFragment,
    SectionBuilderFragment,
    ImageFragment
  ]
)

const PageStaticParamsFragment = graphql(`
  fragment PageStaticParamsFragment on PageRecord @_unmask {
    slug
    pageTitle
    _allSlugLocales {
      locale
      value
    }
    children {
      pageTitle
      slug
      _allSlugLocales {
        locale
        value
      }
      children {
        pageTitle
        slug
        _allSlugLocales {
          locale
          value
        }
        children {
          pageTitle
          slug
          _allSlugLocales {
            locale
            value
          }
        }
      }
    }
  }
`)

export { PageCardFragment, PageFragment, PageStaticParamsFragment }
